import Mapping from './Mapping';
export default Mapping;